<template>
  <div id="promo">
    <div class="container">
      <div class="row">
        <div class="col-lg-7">
          <div class="content">
            <slot>
                <h1>
                  {{ $t("home.heading") }}
                </h1>

                <a
                  href="/register"
                  class="btn btn-main btn-outline-light btn-lg"
                  :title="$t('auth.subscribeToTrial')"
                >
                  {{ $t("auth.register") }} <font-awesome-icon icon="fa-solid fa-arrow-right" />
                </a>
            </slot>
          </div>
        </div>

        <div class="col-lg-5 d-none d-lg-block">
          <div class="row">
            <div class="col-4 list-1">
              <div
                v-for="index in 4"
                :key="index"
                class="card"
              >
                <img
                  :src="`/images/series/global/cover-${index}.webp`"
                  :alt="`${$t('home.coverImage')} ${index}`"
                  class="img-fluid"
                  loading="lazy"
                >
              </div>
            </div>

            <div class="col-4 list-2">
              <div
                v-for="index in 4"
                :key="index"
                class="card"
              >
                <img
                  :src="`/images/series/global/cover-${index + 3}.webp`"
                  :alt="`${$t('home.coverImage')} ${index + 3}`"
                  class="img-fluid"
                  loading="lazy"
                >
              </div>
            </div>

            <div class="col-4 list-3">
              <div
                v-for="index in 4"
                :key="index"
                class="card"
              >
                <img
                  :src="`/images/series/global/cover-${index + 7}.webp`"
                  :alt="`${$t('home.coverImage')} ${index + 7}`"
                  class="img-fluid"
                  loading="lazy"
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PromoHeader",
};
</script>
